import * as React from "react";
import { Positioning, TooltipContainer } from "./styles";
import { Box } from "@mui/material";
import AccessibilityIcon from "@mui/icons-material/Accessibility";
import { useZoom } from "./useZoom";
import { ZoomControl } from "./ZoomControl";

export default function AccessibilityTooltip() {
  const [open, setOpen] = React.useState(false);
  const tooltipRef = React.useRef<HTMLDivElement>(null);
  const { zoom, canIncrease, canDecrease, increase, decrease } = useZoom();

  React.useEffect(() => {
    if (!open) return;

    const handleClickOutside = (event: MouseEvent) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  return (
    <Positioning>
      <Box position="relative" ref={tooltipRef}>
        <TooltipContainer
          $isOpen={open}
          onClick={() => setOpen((prev) => !prev)}
          aria-label="Abrir configurações de acessibilidade"
        >
          <AccessibilityIcon sx={{ fontSize: 24 }} />
        </TooltipContainer>
        <Box
          display={open ? "flex" : "none"}
          position="absolute"
          right={48}
          bottom={0}
          zIndex={15002}
          overflow="visible"
        >
          <ZoomControl
            zoom={zoom}
            canIncrease={canIncrease}
            canDecrease={canDecrease}
            onIncrease={increase}
            onDecrease={decrease}
          />
        </Box>
      </Box>
    </Positioning>
  );
}
